import { Dispatch, Middleware, Action } from "redux";
import { AppInsights } from "applicationinsights-js";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

import { getFeatureToggles } from "../getFeatureToggles";
import * as FeatureToggleNames from "../featureToggleNames";

import { getProperties } from "./getProperties";
import { trackException } from "./trackException";

const useAppInsightsConnectionString = getFeatureToggles()[FeatureToggleNames.UseAppInsightsConnectionString];

const appInsightsLogExceptionMiddlewareOld: Middleware = () => (next: Dispatch<Action>) => async (action: any) => {
    try {
        return await next(action);
    } catch (e) {
        AppInsights.trackException(e, null, getProperties());
        throw e;
    }
};

const appInsightsLogExceptionMiddlewareNew: Middleware = () => (next: Dispatch<Action>) => async (action: any) => {
    try {
        return await next(action);
    } catch (e) {
        trackException(e, SeverityLevel.Error);
        throw e;
    }
};

export const appInsightsLogExceptionMiddleware: Middleware = useAppInsightsConnectionString
    ? appInsightsLogExceptionMiddlewareNew
    : appInsightsLogExceptionMiddlewareOld;
